import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgContainer = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 23",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13.5708 22.3652L0.147342 14.6975L0.125977 4.44336L13.5708 12.1252V22.3652Z",
			fill: "#DA5850"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.5708 12.1252L20.2896 8.28435L6.84838 0.602539L0.125977 4.44345L13.5708 12.1252Z",
			fill: "#FFDFDE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.2892 8.28418L20.3176 18.5418L13.5703 22.3651V12.1251L20.2892 8.28418Z",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M1.16629 5.66602C1.31341 5.66602 1.43267 5.78405 1.43267 5.92965V14.5241C1.43267 14.6697 1.31341 14.7877 1.16629 14.7877C1.01917 14.7877 0.899902 14.6697 0.899902 14.5241V5.92965C0.899902 5.78405 1.01917 5.66602 1.16629 5.66602Z",
			fill: "#B33532"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.45193 6.40625C2.59905 6.40625 2.71832 6.52428 2.71832 6.66988V15.2643C2.71832 15.4099 2.59905 15.528 2.45193 15.528C2.30481 15.528 2.18555 15.4099 2.18555 15.2643V6.66988C2.18555 6.52428 2.30481 6.40625 2.45193 6.40625Z",
			fill: "#B33532"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.73709 7.14648C3.88421 7.14648 4.00347 7.26452 4.00347 7.41011V16.001C4.00347 16.1466 3.88421 16.2647 3.73709 16.2647C3.58997 16.2647 3.4707 16.1466 3.4707 16.001V7.41011C3.4707 7.26452 3.58997 7.14648 3.73709 7.14648Z",
			fill: "#B33532"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.01834 7.88281C5.16546 7.88281 5.28472 8.00084 5.28472 8.14644V16.7409C5.28472 16.8865 5.16546 17.0045 5.01834 17.0045C4.87122 17.0045 4.75195 16.8865 4.75195 16.7409V8.14644C4.75195 8.00084 4.87122 7.88281 5.01834 7.88281Z",
			fill: "#B33532"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.30398 8.62207C6.4511 8.62207 6.57037 8.7401 6.57037 8.8857V17.4802C6.57037 17.6258 6.4511 17.7438 6.30398 17.7438C6.15686 17.7438 6.0376 17.6258 6.0376 17.4802V8.8857C6.0376 8.7401 6.15686 8.62207 6.30398 8.62207Z",
			fill: "#B33532"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.58816 9.3623C7.73528 9.3623 7.85455 9.48034 7.85455 9.62593V18.2204C7.85455 18.366 7.73528 18.484 7.58816 18.484C7.44104 18.484 7.32178 18.366 7.32178 18.2204V9.62593C7.32178 9.48034 7.44104 9.3623 7.58816 9.3623Z",
			fill: "#B33532"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.87527 10.1016C9.02239 10.1016 9.14166 10.2196 9.14166 10.3652V18.9596C9.14166 19.1052 9.02239 19.2233 8.87527 19.2233C8.72815 19.2233 8.60889 19.1052 8.60889 18.9596V10.3652C8.60889 10.2196 8.72815 10.1016 8.87527 10.1016Z",
			fill: "#B33532"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.1595 10.8428C10.3066 10.8428 10.4258 10.9608 10.4258 11.1064V19.7009C10.4258 19.8465 10.3066 19.9645 10.1595 19.9645C10.0123 19.9645 9.89307 19.8465 9.89307 19.7009V11.1064C9.89307 10.9608 10.0123 10.8428 10.1595 10.8428Z",
			fill: "#B33532"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11.4427 11.582C11.5898 11.582 11.709 11.7001 11.709 11.8457V20.4401C11.709 20.5857 11.5898 20.7038 11.4427 20.7038C11.2955 20.7038 11.1763 20.5857 11.1763 20.4401V11.8457C11.1763 11.7001 11.2955 11.582 11.4427 11.582Z",
			fill: "#B33532"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12.7283 12.3223C12.8754 12.3223 12.9947 12.4403 12.9947 12.5859V21.1804C12.9947 21.326 12.8754 21.444 12.7283 21.444C12.5812 21.444 12.4619 21.326 12.4619 21.1804V12.5859C12.4619 12.4403 12.5812 12.3223 12.7283 12.3223Z",
			fill: "#B33532"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.2892 9.13574V17.5463L13.5703 21.3696V12.9766L20.2892 9.13574Z",
			fill: "#B33532"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.5038 20.7204L10.208 22.4241V14.0189L13.5529 12.125L13.786 12.3597L13.5038 20.7204Z",
			fill: "#DA5850"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.7862 12.3438L10.4863 14.2012V22.6024L13.7862 20.8987",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.4861 14.2016L10.208 14.0195V22.4247L10.4861 22.6028V14.2016Z",
			fill: "#DA5850"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.5849 15.0737L20.2891 17.1288V8.37226L23.6339 6.48242L23.867 6.71308L23.5849 15.0737Z",
			fill: "#DA5850"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.8673 6.69727L20.5674 8.55474V16.9599L23.8673 15.2562",
			fill: "#F07C78"
		})
	]
});
export default SvgContainer;
